<wlm-page-wrapper [titleKey]="T_SCOPE + '.title'" [showPageSpinner]="showSpinner">
  <ng-container page-top-buttons>
    <wlm-grid-buttons
      *ngIf="gridSettings"
      [(gridSettings)]="gridSettings"
      [grid]="genericGrid"
      [gridName]="gridName"
      [canLoad]="canLoad"
      (btnClick)="onClickGridBtns($event)"
    >
    </wlm-grid-buttons>
  </ng-container>

  <ng-container page-filters>
    <ct-measurement-filters
      [workspace]="selectedWorkspace"
      [clearAll$]="clearAll$"
      (applyFilters)="onApplyFilter($event)"
    ></ct-measurement-filters>
  </ng-container>

  <ng-container page-content>
    <wlm-generic-grid
      class="wtr-fx-flex-grow generic-grid"
      #genericGrid
      [gridSettings]="gridSettings"
      [gridFiltersForBinding]="gridFiltersForBinding"
      [additionalFilters]="additionalFilters"
      (selectedItemChanged)="getSelectedMeasurePoint($event)"
    ></wlm-generic-grid>
  </ng-container>
</wlm-page-wrapper>
